import axios from "axios";

const urlBase =
  "https://gateway-admin-plus.sistemasinteegra.com.br/api-admin-mobile";

async function getParticipantsId(idCode, idEvent) {
  const config = {
    method: "get",
    url: `${urlBase}/temp/ache/qrcodereader/${idCode}/login/${idEvent}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function createReading(data) {
  const config = {
    method: "post",
    url: `${urlBase}/temp/ache/qrcodereader`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function getReport({ idEvent, limit, offset, columnSearch, search }) {
  const config = {
    method: "get",
    url: `${urlBase}/temp/ache/qrcodereader/report/${idEvent}/event?limit=${limit}&offset=${offset}&columnSearch=${columnSearch}&search=${search}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export { getParticipantsId, createReading, getReport };
